import React from 'react';
import brushlinkIcon from './brushlink_icon.svg';

class SextantInfo extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {

    }

    componentDidMount() {
        // fetch scorecard info
    }

    render() {
        if (this.props.size === "sm" && !this.props.brushScore) {
            return null;
        }
        return (
            <div className="sextant-info">
                <div></div>
                <img alt="Toothbrush" src={brushlinkIcon} width={this.props.size === "sm" ? 64 : 128} height={this.props.size === "sm" ? 64 : 128}  />
                <span>{this.props.brushScore ? this.props.brushScore + "%" : 'No brushing data'}</span>
                <div></div>
            </div>
        );
    }
}

export {
    SextantInfo
};
